import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveAuthSession, getSession } from '../components/ProtectedRoute.jsx';

export default function Login() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resetMsg, setResetMsg] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const session = getSession();
    if (session && session.enquestador_nom) {
      navigate('/app', { replace: true });
    }
  }, []);

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      const data = await res.json();
      if (res.ok && data.ok) {
        saveAuthSession();
        navigate('/enquestador', { replace: true });
      } else {
        setError(data.error || 'Contrasenya incorrecta');
      }
    } catch {
      setError('Error de connexió');
    } finally {
      setLoading(false);
    }
  }

  async function handleForgot(e) {
    e.preventDefault();
    setResetMsg('');
    try {
      await fetch('/api/auth/request-reset', { method: 'POST' });
      setResetMsg("S'ha enviat un correu amb les instruccions.");
    } catch {
      setResetMsg('Error en enviar el correu. Torneu-ho a provar.');
    }
  }

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8">
          <img
            src="/logomontcadayreixac.png"
            alt="Ajuntament de Montcada i Reixac"
            className="h-32 object-contain"
          />
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-600 mb-1">Contrasenya</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full rounded-lg px-4 py-3 text-base focus:outline-none"
              style={{ border: '1px solid #DF273F' }}
              autoFocus
              required
            />
          </div>

          {error && (
            <p className="text-red-600 text-sm">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-dark text-white rounded-lg py-3 text-base font-medium min-h-[44px] disabled:opacity-60"
          >
            {loading ? 'Entrant...' : 'Entrar'}
          </button>
        </form>

        <div className="mt-4 text-center">
          <button
            onClick={handleForgot}
            className="text-sm text-accent underline hover:opacity-75"
          >
            Has oblidat la contrasenya?
          </button>
        </div>

        {resetMsg && (
          <p className="mt-3 text-sm text-gray-600 text-center">{resetMsg}</p>
        )}
      </div>
    </div>
  );
}
